<template>
  <div>
    <footer>
      <div class="container">
        <div class="row">
          <div class="col-12">
            <p>Todos os direitos reservados &copy; {{ ano }}</p>
          </div>
        </div>
      </div>
    </footer>
    <modal-encryption-pdf />
  </div>
</template>

<script>
import ModalEncryptionPdf from './ModalEncryptionPdf.vue'
export default {
  components: { ModalEncryptionPdf },
  data() {
    return {
      dataHoje: '',
      ano: '',
    }
  },
  mounted() {
    this.dataAtual()
  },
  methods: {
    /**
     * Retorna a data atual
     *
     * @returns {string}
     */
    dataAtual() {
      // Obtém a data/hora atual
      var data = new Date()

      // Guarda cada pedaço em uma variável
      var dia = data.getDate() // 1-31
      var mes = data.getMonth() // 0-11 (zero=janeiro)
      var ano4 = data.getFullYear() // 4 dígitos
      // var hora    = data.getHours();          // 0-23
      // var min     = data.getMinutes();        // 0-59
      // var seg     = data.getSeconds();        // 0-59

      // Formata a data e a hora (note o mês + 1)
      var str_data = dia + '/' + (mes + 1) + '/' + ano4
      // var str_hora = hora + ':' + min + ':' + seg;
      this.ano = ano4
      this.dataHoje = str_data
    },
  },
}
</script>

<style scoped>
footer {
  background: #e9ecef;
  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.1);
  color: #0f1f3e;
  text-align: center;
  border-top: 1px solid rgba(247, 247, 247, 0.2);
  padding: 20px 0;
  text-align: center;
}

footer p {
  margin-bottom: 0;
}

@media (max-width: 768px) {
  .footer {
    position: initial;
  }
}
</style>
